// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__YJOfk","Image":"Card_Image__GZqJW","Content":"Card_Content__cy5r5","Date":"Card_Date__fTaYe","Tags":"Card_Tags__FAM3Q","Tag":"Card_Tag__Q-6NN"};